<div
  class="state"
  [class.state--error]="kind() === 'error'"
  [attr.role]="kind() === 'error' ? 'alert' : 'status'"
>
  @switch (kind()) {
    @case ('loading') {
      <div class="radar" aria-hidden="true"></div>
    }
    @case ('error') {
      <img src="/assets/warning.svg" alt="" />
    }
  }
  <p class="state__title">{{ title() }}</p>
  @if (message(); as message) {
    <p>{{ message }}</p>
  }
  <ng-content />
</div>
